import React, { useState } from "react";
import PaymentRecordPopup from "../RecordPayment/PaymentRecordPopup";
import PaymentLinkPopup from "../PaymentLinkPopup/PaymentLinkPopup";
import PaymentLinkSent from "../PaymentLinkPopup/PaymentLinkSent";
import styles from "./PaymentDetails.module.css";
import paidCheck from "../../../../../assets/images/paid-check.svg";
import CopyLinkPopup from "../../../../../components/Payment/CopyLinkPopup";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import { useDispatch } from "react-redux";
import CopyLinkPopupForBasic from "../../../../../components/Payment/CopyLinkPopupForBasic";
import { useSelector } from "react-redux";

function BasicRegularDetails(props: any) {
  const {
    leadData,
    RecordPayment,
    SendPaymentLink,
    EditRecordPayment,
    isFirstPaymentRequestedOrFailed,
    filteredPaymentRequests,
    hasLeadAccess,
    selectedCurrency,
    // setShowCopyLinkPopup,
    canRecordPayment,
    filteredLeadAllPaymentList,
  } = props;
  const dispatch = useDispatch();

  const [showCopyLinkPopupForBasic, setShowCopyLinkPopupForBasic] =
    useState(false);
  const [copied, setCopied] = React.useState(false);
  const batchEndDateMilliSeconds =
    leadData?.bacthEndDate?.toString()?.length !== 13
      ? leadData?.bacthEndDate * 1000
      : leadData?.bacthEndDate;

  const batchStartDateMilliSeconds =
    leadData?.batchStartDate?.toString()?.length !== 13
      ? leadData?.batchStartDate * 1000
      : leadData?.batchStartDate;

  React.useEffect(() => {
    if (copied) {
      dispatch(
        setToastNotification({
          message: String("URL copied!"),
          type: "success",
          snackOpen: true,
        })
      );
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  const { sendPaymentLinkSuccess, sendPaymentLinkUrl } = useSelector(
    (state: any) => state.nurture
  );
  const instituteData = useSelector(
    (state: any) => state.institute.instituteDetails
  );
  const hasNurturePay =
    instituteData &&
    Array.isArray(instituteData.integrationsOpted) &&
    instituteData?.integrationsOpted?.includes("NURTURE_PAY_EASEBUZZ");

  React.useEffect(() => {
    if (
      sendPaymentLinkSuccess !== true &&
      sendPaymentLinkSuccess !== false &&
      sendPaymentLinkUrl?.data?.paymentLink !== ""
    ) {
      if (hasNurturePay === true) {
        setTimeout(() => {
          setShowCopyLinkPopupForBasic(true);
        }, 500);
      }
    }
  }, [sendPaymentLinkSuccess]);

  return (
    <div className={styles.basicRegularWrap}>
      <div className={styles.basicRegularLeft}>
        <div className={styles.basicRegularAmount}>
          Balance : {""}
          {/* {leadData?.balanceAmount?.toLocaleString("en-IN", {
style: "currency",
currency: "INR",
})} */}
          {selectedCurrency + " " + leadData?.balanceAmount.toFixed()}
        </div>
      </div>
      <div className={styles.basicRegularRight}>
        {leadData?.balanceAmount > 0 ? (
          <>
            {hasLeadAccess && (
              <>
                {canRecordPayment && (
                  <PaymentRecordPopup
                    balanceAmountToBePaid={leadData?.balanceAmount}
                    basePrice={leadData?.paymentDetails?.finalAmount}
                    discountMetric={leadData?.paymentDetails?.discountMetric}
                    discount={leadData?.paymentDetails?.discount}
                    RecordPayment={RecordPayment}
                    amountToBePaid={leadData?.balanceAmount}
                    leadData={leadData}
                    emiId={""}
                    isTable={false}
                    paymentType={"REGULAR"}
                    finalBatchPrice={leadData?.paymentDetails?.finalAmount}
                    totalPaidAmount={leadData?.batchAmountPaid}
                    autoDebitRaised={false}
                    selectedCurrency={selectedCurrency}
                    batchEndDateMilliSeconds={batchEndDateMilliSeconds}
                    batchStartDateMilliSeconds={batchStartDateMilliSeconds}
                    filteredLeadAllPaymentList={filteredLeadAllPaymentList}
                  />
                )}
                {!isFirstPaymentRequestedOrFailed ? (
                  <PaymentLinkPopup
                    finalBatchPrice={leadData?.paymentDetails?.finalAmount}
                    totalPaidAmount={leadData?.batchAmountPaid}
                    isOneTime={false}
                    isTable={false}
                    paymentType={"REGULAR"}
                    SendPaymentLink={SendPaymentLink}
                    leadData={leadData}
                    amountToBePaid={leadData?.balanceAmount}
                    selectedCurrency={selectedCurrency}
                  />
                ) : (
                  <PaymentLinkSent
                    filteredPaymentRequests={filteredPaymentRequests}
                    EditRecordPayment={EditRecordPayment}
                    SendPaymentLink={SendPaymentLink}
                    finalBatchPrice={leadData?.paymentDetails?.finalAmount}
                    totalPaidAmount={leadData?.batchAmountPaid}
                    isOneTime={false}
                    paymentType={"REGULAR"}
                    leadData={leadData}
                    isFirstPaymentRequestedOrFailed={
                      isFirstPaymentRequestedOrFailed
                    }
                    amountToBePaid={
                      isFirstPaymentRequestedOrFailed?.amountReceived
                    }
                  />
                )}
              </>
            )}
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                background: " rgba(17, 200, 155, 0.1)",
                borderRadius: "4px",
                padding: "4px 10PX",
                color: "#3DB985",
                fontSize: "12PX",
                fontWeight: "500",
              }}
            >
              Paid
            </div>
            <img src={paidCheck} alt="paidCheck" />
          </div>
        )}
      </div>
      {showCopyLinkPopupForBasic && (
        <CopyLinkPopupForBasic
          showCopyLinkPopup={showCopyLinkPopupForBasic}
          onClose={() => {
            setShowCopyLinkPopupForBasic(false);
          }}
          setCopied={setCopied}
        />
      )}
    </div>
  );
}

export default BasicRegularDetails;
